module.exports = __webpack_public_path__ + "static/media/licence1-ever.b0b4b4ce.png";